module.exports = __webpack_public_path__ + "static/media/main-photo.b015f61f.webp";